import { useState } from "react";
import PermissionGate from "../layout/PermissionGate";

const OrdableBranchKey = ({ item, setRegenerate, setBranchId }) => {
    const [hidden, setHidden] = useState(true);
    const [copied, setCopied] = useState(false);

    return (
        <tr className="text-center">
            <td>{item?.name ?? ""}</td>
            <td>
                {item?.ordableBranchId ? (
                    item.ordableBranchId
                ) : (
                    <span className="badge badge-light-secondary">Not linked yet</span>
                )}
            </td>
            <td>
                {item?.hasLocation === true ? (
                    <span className="badge badge-light-success">Set</span>
                ) : (
                    <span className="badge badge-light-warning" title="Set the branch coordinates before switching this store over">
                        Missing
                    </span>
                )}
            </td>
            <td>
                {item?.ordableApiKey && hidden === false
                    ? item?.ordableApiKey
                    : "*".repeat(74)}
            </td>
            <td className="text-center">
                <div className="d-flex justify-content-center gap-2">
                    <button
                        className="btn btn-sm btn-light text-center"
                        title={`${hidden ? "Show" : "Hide"}`}
                        onClick={() => {
                            setHidden((prev) => !prev);
                        }}
                    >
                        <i
                            className={`bi-duotone ms-1 bi-${hidden ? "eye" : "eye-slash"}`}
                        ></i>
                    </button>
                    <PermissionGate
                        required={`regenerate_ordable_branch_keys`}
                        fallback={<></>}
                    >
                        <button
                            className="btn btn-sm btn-light text-center"
                            title="Regenerate"
                            onClick={() => {
                                setRegenerate((prev) => !prev);
                                setBranchId(item?.branchId);
                            }}
                        >
                            <i className={`bi-duotone ms-1 bi-arrow-repeat`}></i>
                        </button>
                    </PermissionGate>
                    <button
                        onClick={async () => {
                            await navigator.clipboard.writeText(item?.ordableApiKey ?? "");
                            setCopied(true);
                            setTimeout(() => setCopied(false), 2000);
                        }}
                        className="btn btn-sm btn-light text-center"
                        title={`${copied ? "Copied" : "Copy"}`}
                    >
                        <i
                            className={`bi-duotone ms-1 bi-${copied === false ? "copy" : "clipboard-check-fill"
                                }`}
                        ></i>
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default OrdableBranchKey;